<template>
  <section
    class="statistics-section"
    :style="{
      backgroundImage: `url(${getCDNlink(
        'assets/new-assets/Statistics-BG.webp'
      )})`,
    }"
  >
    <div class="container">
      <div class="statistics-grid">
        <div class="statistic-item">
          <h3 class="statistic-value">+1 Bn</h3>
          <p class="statistic-label">Shipment Records</p>
        </div>

        <div class="statistic-item">
          <h3 class="statistic-value">+200 Mn</h3>
          <p class="statistic-label">Legal Records</p>
        </div>

        <div class="statistic-item">
          <h3 class="statistic-value">+200</h3>
          <p class="statistic-label">Compliance Lists</p>
        </div>

        <div class="statistic-item">
          <h3 class="statistic-value">+400</h3>
          <p class="statistic-label">Data Points</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from "@/config";

export default {
  name: "StatisticsComp",
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }
      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>

<style scoped>
.statistics-section {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  text-align: center;
  font-size: 48px;
  color: #fff;
  font-family: Figtree;
  padding: 80px 140px;
}

.container {
  margin: 0;
  width: -webkit-fill-available;
}

.statistics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0 4rem;
}

.statistic-item {
  text-align: center;
}

.statistic-value {
  font-size: 3.5rem;
  font-weight: 700;
  /* color: #ffffff; */
  margin: 0 0 0.5rem;
  line-height: 1;
  background: radial-gradient(
    82.47% 140.95% at 31.38% -13.87%,
    #fff 36%,
    #ffece0 64%,
    #046BE1 81%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.prefix {
  font-weight: 500;
}

.highlight {
  color: #046BE1;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #fff 36%,
    #ffece0 64%,
    #046BE1 81%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.statistic-label {
  font-size: 1.125rem;
  font-weight: 500;
  color: #ffffff;
  margin: 0;
  opacity: 0.9;
}

/* Responsive styles */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .statistic-value {
    font-size: 3rem;
  }

  .statistic-label {
    font-size: 1rem;
  }
}

@media (max-width: 767px) {
  .statistics-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem 0;
  }

  .statistics-section {
    padding: 45px 40px;
  }

  .statistic-label {
    font-size: 16px;
  }
  .statistic-value {
    font-size: 36px;
  }
}

@media (max-width: 480px) {
  .statistics-section {
    padding: 3rem 1rem;
  }
.statistics-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem 0;
  }
  .statistic-label {
    font-size: 16px;
  }
  .statistic-value {
    font-size: 36px;
  }
}
</style>
